<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 0.8s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes sb-01 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #sb-01 {
    animation-name: sb-01;
  }
  @keyframes sb-02 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #sb-02 {
    animation-name: sb-02;
  }
  

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 405.6 585.5" height="100%" width="100%">>
<g class:paused={isPaused}>
  <g class="shapes" bind:this={rootElement}>
    <g id="sb-02">
      <path
        fill="var(--hair)"
        d="m213 1 13 5c12 4 22 13 31 21l6 4c6 3 6 8 1 12l-11 5c-3-3-7-4-9-8-1-3-4-5-7-4s-4 3-4 7-1 8-7 7c-2 0-4 2-5 3l-5 10c-2 2-2 5-5 4s-3-4-2-7a20 20 0 0 0 0-11c-1-5-5-7-9-7s-7 3-8 7c-2 9-8 15-17 17-1-2 0-4 1-7l4-22c4-15 10-29 27-35l1-1Z"
      />
      <path
        fill="var(--shirt)"
        d="m230 164-7-10c-2-2-3-2-4 0l-17 16a39 39 0 0 1-12 9c-6 2-6 4-2 8 7 7 14 15 23 19 4 3 7 6 12 7 3 4 8 4 12 7 0 14-2 27-3 40a24 24 0 0 1-1 5 41 41 0 0 1-20 14c-14 5-29 3-43 1-13-2-25-4-33-15-1-4 0-6 2-9 5-8 10-17 8-28-4-21-6-43-11-64-1-6-4-12-4-18-1-22 5-42 24-56 4-3 6-8 10-10l10 9c6 6 14 11 21 16 2 2 5 1 5-1 3-7 6-4 9-1 2 3 6 5 9 2 4-4 11-6 14-12 3-5 7-6 11-6 5 3 10-1 15 2-5 2-6 7-4 10 3 5 0 9-2 13a26 26 0 0 0-1 9c-2 7-7 11-14 11h-6c-7 0-7 0-5 7 2 8 4 16 4 25Z"
      />
      <path
        fill="var(--pants)"
        d="M135 265c8 11 20 13 33 15 14 2 29 4 43-1a41 41 0 0 0 20-14c5 24 17 47 24 71a40 40 0 0 1 2 12c-3 8-9 11-17 12h-27c-9 0-9 0-12-10l-16 38c-1 3-3 6-6 5-5 0-7 2-8 6 0 2-2 3-4 3-5 0-9-1-13-4-3-1-6-3-9-2-8 2-15 0-22-5v-6c4-14 9-27 10-40 3-20 4-40 2-61a63 63 0 0 1 0-19Z"
      />
      <path
        fill="var(--flesh)"
        d="M217 360h23c8-1 14-4 17-12 3 1 3 3 4 5l4 9c8 11 5 21-1 32a176 176 0 0 0-12 30c-5 16-12 32-16 48l-1 8c-4 2-5 4-3 8s-1 7-3 9c-1 3-4 2-6 2-9-2-13-7-14-15 4-15 8-29 7-45a138 138 0 0 1 3-34 38 38 0 0 1 6-14c5-8 5-12-1-20l-7-11Z"
      />
      <path
        fill="var(--flesh)"
        d="M243 87c-4 0-8 1-11 6-3 6-10 7-14 12-3 3-7 0-9-2-3-3-6-7-9 1 0 2-3 3-5 1-7-5-15-10-21-16l-10-9a18 18 0 0 0 11-14c9-2 15-8 17-17 1-4 3-7 8-7s8 2 9 7a20 20 0 0 1 0 11c-1 3-1 6 2 7s3-2 5-4l5-10c1-1 3-3 5-3 6 1 7-3 7-7 0-3 0-6 4-7s6 1 7 4c2 4 6 5 9 8a45 45 0 0 1-8 20c-4 6-3 13-2 19Z"
      />
      <path
        fill="var(--hair)"
        d="M69 530a5 5 0 0 1 1 4c0 8 4 13 12 16l28 12c3 1 9 3 8 8s-5 7-9 9a28 28 0 0 1-11 2 3102 3102 0 0 1-41-2c-14-6-26-14-38-22-3-3-3-4-1-7l18-26c1-2 1-4 4-3-1 6-3 13 0 19 2 3 3 7 7 7 5-1 13-6 13-9 0-6 3-9 9-8Z"
      />
      <path
        fill="var(--pants)"
        d="m281 511-21-8c-11-4-20-10-24-22l-2-1c-3 2-5 4-2 8 2 4-1 7-3 9-1 3-4 2-7 2-8-2-12-8-13-15-2-1-3 0-3 2-1 9-6 17-7 26-1 4 0 6 4 7a1 1 0 0 0 1 0h2a5 5 0 0 0 4 1h8l6 1h3l7 1h3l30 1c5 0 9 0 13-2 3-1 7-2 7-5s-4-4-6-5Z"
      />
      <path
        fill="var(--flesh)"
        d="M211 206c4 3 7 6 12 7 3 4 8 4 12 7a48 48 0 0 1 6 2c5 2 9 0 12-4 6-12 12-23 16-36 6-18 8-36 10-54 0-4 1-6 5-6 26 1 51-5 76-11 9-2 10-2 15 7a15 15 0 0 0 22 6c3-2 5-6 9-6v-11l-2-2c-1-7-5-7-11-7s-11 0-16-2-10-2-16-1h-11l-10-1c-20-3-41-7-62-3a6 6 0 0 1-4-2c-5-3-9-5-13 0h-3c-5 2-7 7-4 10 2 5 0 9-2 13a26 26 0 0 0-1 9c3-2 6-1 9-1 4 2 3 6 2 9-2 9-6 18-10 25s-7 15-12 21c-2 3-4 2-5 0l-5-11-7-10c-2-2-3-1-4 0l-17 16a39 39 0 0 1-12 9c-6 2-6 4-2 8 7 7 14 15 23 19M154 399c-3-2-6-4-9-3-8 2-15 0-22-5l-3 8c-2 5-4 11-9 15-6 4-11 10-17 16-5 5-11 11-14 18-6 8-10 18-13 27v1a7 7 0 0 0-3 5c-6 14-16 26-24 40-1 6-3 13 0 19 2 3 3 7 7 7 4-1 12-6 13-9 0-6 3-9 9-8 2-8 6-14 10-20 5-8 13-14 17-22a19 19 0 0 0 8-9c3-2 4-4 5-7a6 6 0 0 0 4-5c4-4 8-8 9-13l16-16c7-7 16-13 21-22l8-14c-5 0-9-1-13-3Z"
      />
    </g>
    <g id="sb-01">
      <path
        fill="var(--hair)"
        d="M38 496c2 0 4-1 4 2 0 4 2 5 5 7 9 8 20 8 32 6 4 0 9-1 11 5s-2 9-6 12a48 48 0 0 1-25 7c-12 0-23 2-33 7-6 2-12 4-18 1-4-1-7-2-6-8a3 3 0 0 0-2-2v-13c3-2 2-5 3-7s1-4 4-4l4 4a18 18 0 0 0 24 1c3-2 5-4 3-8a13 13 0 0 1 0-10ZM233 562c-1-6-6-7-12-7-5 0-12 1-17-2-13-7-29-10-39-23a15 15 0 0 1-2 9c-2 3-3 6-1 8 2 3 0 5-2 7-6 4-12 4-18 1-7-2-9-9-9-15a4 4 0 0 0-5 3c-2 7-4 14-3 21l2 9c-1 7 1 10 7 11h15c7 0 14-1 21 1h32a2 2 0 0 0 0-1c9 0 17-2 25-6 5-3 8-10 6-16Z"
      />
      <path
        fill="var(--shirt)"
        d="M129 208a152 152 0 0 0-4 46c0 4-3 9 0 14l-3 2c-6-6-14-8-23-6a83 83 0 0 1-32 2c-12-2-24-1-36-2-2-6 1-12 3-18a69 69 0 0 0 2-16l3-30a303 303 0 0 1 11-68 76 76 0 0 1 20-35l11-11a7 7 0 0 1 6-4h7c8-1 12 4 16 10 3 5 6 8 13 7 10 10 17 22 25 34 3 5 7 10 12 14 0 2 1 4-2 5-6 1-11 5-17 7-4 0-7 1-9 5a54 54 0 0 0-6 3c-3 1-4 3-1 6 2 1 3 4 6 3 4 5 4 10 2 15-2 6-4 11-4 17Z"
      />
      <path
        fill="var(--pants)"
        d="M31 264c12 1 24 0 36 2a83 83 0 0 0 32-2c9-2 17 0 23 6 1 10 5 18 12 25a82 82 0 0 1 20 34l8 21c1 1 2 3 1 4l-8 4-39 23-11 4-4-8c-2-4-5-5-10-4a65 65 0 0 1-28 3c-4-1-5-4-5-7 1-21-6-39-19-55-11-15-11-32-8-50Z"
      />
      <path
        fill="var(--flesh)"
        d="m116 381 39-23 8-4 15 33c2 4 2 9 0 14-4 10-9 20-8 31 4 23-1 45-3 67l-2 31a15 15 0 0 1-2 9c-2 3-3 6-1 8 2 3 0 5-2 7-6 4-12 4-18 1-7-2-9-9-9-15 0-17 1-34-1-50-1-5-1-9-3-13-8-17-6-34 1-51 3-4 3-10 4-15 0-7-3-12-8-17-3-4-9-7-10-13Z"
      />
      <path
        fill="var(--flesh)"
        d="M63 375a65 65 0 0 0 28-2c5-1 8 0 10 4l4 8a4 4 0 0 0-1 3 25 25 0 0 1-8 19c-12 11-20 25-28 39-8 15-19 28-27 43-2 2-3 5-3 7a13 13 0 0 0 0 10c2 4 0 6-3 8a18 18 0 0 1-24-1l-4-4 19-55c3-8 3-16 6-23 5-11 11-20 21-27 8-6 12-13 10-23v-6ZM123 99c-7 1-10-2-13-7-4-6-8-11-16-10h-7c3-5 6-11 6-18 2 3 4 4 7 1s6-6 7-11a59 59 0 0 1 3-12c2-5 6-7 11-6s5 5 5 9a16 16 0 0 0 0 4c0 2-2 5 1 6 4 0 7-1 8-5a18 18 0 0 0 0-12c-1-3-1-5 3-7 2 0 3-2 2-4 0-5 2-7 7-6l8 6c-1 7 2 15 0 23-1 2 3 6 4 9s2 6-2 8c-3 2-1 6-3 9l-7 11c0 3-4 2-7 2s-7-5-11 0a32 32 0 0 0-6 10Z"
      />
      <path
        fill="var(--hair)"
        d="m155 27-8-6c-5-1-7 1-7 6 1 2 0 4-2 4-4 2-4 4-3 7a18 18 0 0 1 0 12c-1 4-4 5-8 5-3-1-1-4-1-6a16 16 0 0 1 0-4c0-4 0-8-5-9s-9 1-11 6a59 59 0 0 0-3 12c-1 5-4 8-7 11s-5 2-7-1c-4-14-6-29-5-44C89 7 98 0 111 0c14 1 27 4 39 9l8 2c3 1 5 1 6 4s-1 5-3 7l-6 5Z"
      />
      <path
        fill="var(--flesh)"
        d="M132 164a54 54 0 0 0-6 3c-3 1-4 3-1 6 2 1 3 4 6 3 4 5 4 9 2 15s-4 11-4 17c3 1 5 1 6-2 2 0 3-1 3-3l1-1a3 3 0 0 0 2-2l4-2a2 2 0 0 0 2-2c4-3 7 1 11 2l2 1 12 7c5 2 10 4 14 0 3-3 6-4 10-5 5-2 11-5 15-9 12-11 25-19 36-31 3-4 8-7 13-9 5-1 9-4 13-7 6-6 6-14 2-21-2-3-6-4-7-8-1-3-11-5-13-3-4 7-13 11-12 22 0 2-2 4-3 5-17 11-34 22-53 28-3-1-5 1-7 1a1 1 0 0 0-1 0c-7-7-7-7-1-15l2-3c5-7 12-11 16-18 3-4 5-10 2-14a28 28 0 0 0-17-13 6 6 0 0 0-3 0c-4 2-11 15-10 19 2 6 2 11-4 16l-4 6c0 2 1 4-2 5-6 1-11 5-17 7-4 0-7 1-9 5"
      />
    </g>
  </g>
  </g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>